import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-field', 'required', 'Обязательно');
Labels.set('ui-field', 'add', 'Добавить');
Labels.set('ui-field', 'remove', 'Удалить');
